import _ from "lodash";
import { CONTAINS } from "../../common/reports/reportConstants";

export const debounceCategoryName = _.debounce(
  async (apiFunction, value, setData) => {
    try {
      const payload = {
        orderBy: [{ fieldName: "name", orderType: "asc" }],
        filters: [
          {
            fieldName: "name",
            fieldType: { type: "string", operation: CONTAINS },
            fieldValue: value,
          },
        ],
        includeFields: ["name", "id"],
      };
      const response = await apiFunction(payload);
      if (response.status === "success") {
        const updatedResult = response.result.rows?.map((category) => {
          return {
            id: category.id,
            name: category.name,
          };
        });
        setData(updatedResult);
      }
    } catch (error) {
      console.log(error);
    }
  },
  300
);

export const debounceEntityName = _.debounce(
  async (apiFunction, value, setData) => {
    const payload = {
      orderBy: [{ fieldName: "entityName", orderType: "asc" }],
      filters: [
        {
          fieldName: "entityName",
          fieldType: { type: "string", operation: CONTAINS },
          fieldValue: value,
        },
      ],
      includeFields: ["entityName", "entityId"],
    };

    try {
      const response = await apiFunction(payload);
      if (response.status === "success") {
        const updatedResult = response.result.rows?.map((entity) => {
          return {
            entityId: entity?.entityId,
            entityName: entity?.entityName,
          };
        });
        setData(updatedResult);
      }
    } catch (error) {
      console.log(error);
    }
  },
  300
);

export const debounceBankName = _.debounce(
  async (apiFunction, value, setData) => {
    const payload = {
      orderBy: [{ fieldName: "bankName", orderType: "asc" }],
      filters: [
        {
          fieldName: "bankName",
          fieldType: { type: "string", operation: CONTAINS },
          fieldValue: value,
        },
      ],
      includeFields: ["bankName", "bankId", "accountNo"],
    };

    try {
      const response = await apiFunction(payload);
      if (response.status === "success") {
        const updatedResult = response.result.rows?.map((bank) => {
          return {
            bankId: bank?.bankId,
            bankName: bank?.bankName,
            accountNo: bank?.accountNo,
          };
        });
        setData(updatedResult);
      }
    } catch (error) {
      console.log(error);
    }
  },
  300
);
